<div data-test="confirmDialog">
  <h1 mat-dialog-title>
    {{ settings.titleText }}
  </h1>

  <div mat-dialog-content class="pt-4 pb-6">
    <div class="text-14">{{ settings.bodyText }}</div>
  </div>

  <div
    mat-dialog-actions
    class="dialog__actions pt-2"
    [class.dialog__actions--compact]="!settings.miscText">

    <button *ngIf="settings.miscText" app-button buttonTheme="light" [mat-dialog-close]>{{ settings.miscText }}</button>

    <div>
        <button *ngIf="settings.cancelEnabled" class="mr-1" app-button buttonTheme="light" [mat-dialog-close]="false">{{ settings.cancelText }}</button>
        <button *ngIf="settings.confirmEnabled" app-button buttonType="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ settings.confirmText }}</button>
    </div>

  </div>
</div>